import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Navigation } from './Navigation'
import { StaticQuery, graphql } from 'gatsby'
import { Theme } from './Theme'
import { Helmet } from 'react-helmet'
import {
  MobileMenuProvider,
  MobileNavigationPanel
} from './MobileNavigation'

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
`
const ContentExpander = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`

const ScrollBox = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

const StyledFooter = styled.div`
  background: ${props => props.theme.footerColor};
  color: #fff;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: flex-end;
  padding: 1rem;
  flex-grow: 0;
`

const Footer = () => {
  const query = graphql`
  {
    siteSettings:allFile(filter:{name:{eq:"siteSettings"}}){
      edges {
        node {
          childMarkdownRemark{
            frontmatter{
              headerAndFooter{
                footerText
              }
            }
          }
        }
      }
    }
  }
  `

  const render = ({ siteSettings }) => {
    const { footerText } = siteSettings.edges[0].node.childMarkdownRemark.frontmatter.headerAndFooter
    return <StyledFooter>{footerText}</StyledFooter>
  }

  return <StaticQuery render={render} query={query} />
}

export const Layout = ({ children }) => {
  useEffect(() => {
    // Removed March 3rd, 2020 due to Board Member not liking it.
    //  <3 Victor
    //
    // FB.Event.subscribe('customerchat.load', function () {
    //   console.log('Customer Chat Loaded.')
    //   FB.CustomerChat.show(true)
    // })
  }, [])

  return (
    <Theme>
      <MobileMenuProvider>
        <StyledLayout>
          <Navigation type='top' />
          <MobileNavigationPanel />
          <ScrollBox>
            <ContentExpander>
              {children}
            </ContentExpander>
            <Navigation type='bottom' />
            <Footer />
          </ScrollBox>
        </StyledLayout>
      </MobileMenuProvider>
      <Helmet>
        <meta name='google-site-verification' content='QXG5763lp_D54rMYqPdX-ZLz47lwg2OD6oreQHf0TQo' />
      </Helmet>
    </Theme>
  )
}
